import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'classlist-polyfill';
import 'match-media';

if (!global._babelPolyfill) {
    require('babel-polyfill');
}

let renderer = document.getElementById('application').getAttribute('data-renderer');

// Require frontend/backend depending on renderer.
switch (renderer) {
    case 'frontend' :

        try {
            require('./frontend');
        } catch (e) {
            console.log('Could not find frontend index.js.');
        }

        break;

    case 'backend' :
        try {
            require('./core/admin');
        } catch (e) {
            console.log('Could not find admin index.js. Are you sure the core repo is included?');
        }

        break;

    default :
        console.log('Invalid renderer');
        break;
}


// WEBPACK FOOTER //
// ./src/index.js